import React from 'react';
import classNames from 'classnames';

import ActionMenu from 'components/partials/action-menu/action-menu';
import Heading from 'components/partials/heading/heading';
import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

import type { ActionMenuItem } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-manager/goal/goal.helpers';

const getDetailsTitle = (isNew: boolean, isEditMode: boolean): string => {
  const goalStatuses = {
    new: 'New Goal',
    edit: 'Edit Goal',
    read: 'Goal Details',
  };

  return (
    (isNew && goalStatuses.new) ||
    (isEditMode && goalStatuses.edit) ||
    goalStatuses.read
  );
};

const getHeaderTitle = (
  isNew: boolean,
  isEditMode: boolean,
  activeTab: string
): string | undefined => {
  const TABS: Record<string, string> = {
    details: getDetailsTitle(isNew, isEditMode),
    history: 'Version History',
    criticalElements: 'Linked Critical Elements',
  };

  return TABS[activeTab];
};

interface GoalHeaderProps {
  actionMenuItems: ActionMenuItem[];
  onEditClick: () => void;
  customClass?: string;
  isNew: boolean;
  isEditMode: boolean;
  onCancel: (isNew: boolean) => void;
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  activeTab: string;
  onMonitoringClick: () => void;
  shouldShowMonitoring: boolean;
}

const GoalHeader = ({
  actionMenuItems,
  onEditClick,
  customClass,
  isNew,
  isEditMode,
  onCancel,
  onSubmit,
  activeTab,
  onMonitoringClick,
  shouldShowMonitoring,
}: GoalHeaderProps): React.JSX.Element => (
  <div
    className={classNames(
      'flex justify-between items-center flex-wrap min-h-11',
      customClass
    )}
  >
    <Heading
      variant="h3"
      customClass="capitalize font-bold"
      data-testid="goal-header-title"
    >
      {getHeaderTitle(isNew, isEditMode, activeTab)}
    </Heading>

    {activeTab === 'details' &&
      (isNew || isEditMode ? (
        <div className="flex items-center gap-2">
          <Button
            variant="reserve-invert"
            onClick={() => onCancel(isNew)}
            data-testid="cancel-goal-header-button"
          >
            Cancel
          </Button>
          <Button
            variant="brand-filled"
            onClick={onSubmit}
            data-testid="save-goal-header-button"
          >
            Save changes
          </Button>
        </div>
      ) : (
        <ActionMenu
          buttonName="Edit goal"
          options={actionMenuItems}
          onEditClick={onEditClick}
        />
      ))}

    {activeTab === 'criticalElements' &&
      !isNew &&
      !isEditMode &&
      shouldShowMonitoring && (
        <Button
          variant="reserve-outlined"
          onClick={onMonitoringClick}
          iconBefore={<Icons.Steps aria-label="StepsIcon" />}
        >
          Monitoring details
        </Button>
      )}
  </div>
);

export default GoalHeader;
